
import React from 'react';  
import { SecondaryGridRow } from './SecondaryGridRow';

export const SecondaryGrid = ({ headers, rows, onOpenModal }) => {
  const totalColumns = headers.reduce((count, header) => {
    return count + (header.subheaders ? header.subheaders.length : 1);
  }, 0);

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${totalColumns}, 1fr)`,
    gap: '0rem',
  };

  return (
    <div style={gridStyle}>
      {/* Headers */}
      {headers.map((header, index) => {
        if (typeof header === 'string') {
          return (
            <div 
              key={index} 
              className="grid-header-secondary single" 
              style={{ gridRow: '1 / 3' }}
            >
              {header}
            </div>
          );
        } else {
          return (
            <React.Fragment key={index}>
              <div 
                className="grid-header-secondary split-main-title-secondary" 
                style={{ 
                  gridColumn: `span ${header.subheaders.length}`,
                  gridRow: '1' // <-- Add this line
                }}
              >
                {header.title}
              </div>

              {header.subheaders.map((subheader, subIndex) => (
                <div 
                  key={subIndex} 
                  className="grid-header-secondary split-subheader-secondary"
                  style={{ gridRow: '2' }} // <-- Add this line
                >
                  {subheader}
                </div>
              ))}
            </React.Fragment>
          );
        }
      })}

      {/* Rows */}
      {rows.map((row, index) => (
        <SecondaryGridRow 
          key={row.id} 
          row={row} 
          rowIndex={index} 
          numHeaders={totalColumns} 
          onOpenModal={onOpenModal} 
        />
      ))}
    </div>
  );
};